import { render, staticRenderFns } from "./EmailSubscriberForm.vue?vue&type=template&id=20b22130"
import script from "./EmailSubscriberForm.vue?vue&type=script&lang=js"
export * from "./EmailSubscriberForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports